import processHtmlAttributes from "../../../common/html-attributes"

static var ignoredAttributes = [
    "status",
    "a11yText",
    "icon",
    "iconClass",
    "class",
    "root",
    "headerRoot",
    "a11yRoleDescription",
    "prefixClass",
    "title",
    "footer",
    "type",
    "mainRoot",
    "noA11yLabel"
];

$ var status = input.status;
$ var prefixClass = input.prefixClass;
<${input.root || "section"}
    aria-labelledby=(!input.noA11yLabel && component.elId('status'))
    aria-roledescription=input.a11yRoleDescription
    class=[prefixClass, input.class]
    ...processHtmlAttributes(input, ignoredAttributes)>
    <if(input.icon !== "none")>
        <${input.headerRoot || "div"} class=`${prefixClass}__header` id:scoped="status"
        >
            <if(status === "confirmation" || status === "celebration")>
                <ebay-confirmation-filled-icon
                    a11y-text=input.a11yText
                    a11y-variant="label"
                    class=input.iconClass/>
            </if>
            <else-if(status === "attention")>
                <ebay-attention-filled-icon
                    a11y-variant="label"
                    a11y-text=input.a11yText
                    class=input.iconClass/>
            </else-if>
            <else-if(status === "information")>
                <ebay-information-filled-icon
                    a11y-variant="label"
                    a11y-text=input.a11yText
                    class=input.iconClass/>
            </else-if>
        </>
    </if>
    <${input.mainRoot || "div"} class=`${prefixClass}__main`>
        <if(input.title)>
            <${input.title.as || "h2"}
                ...input.title
                class=[`${prefixClass}__title`, input.title.class]>
                <${input.title.renderBody}/>
            </>
        </if>
        <${input.renderBody}/>
    </>
    <if(input.footer)>
        <div class=`${prefixClass}__footer`>
            <${input.footer}/>
        </div>
    </if>
</>
